import {clientFieldsService} from "../../settings/services/clientFieldsService";
import {wizardsService, campaignService} from "@/modules/common/services";

const state = {
  wizard: null,
  campaigns: null,
  selectedCampaign: null,
  preSelectedCampaignUid: null
};

const getters = {
  wizard: state => {
    return state.wizard
  },
  campaigns: state => {
    return state.campaigns
  },
  selectedCampaign: state => {
    return state.selectedCampaign
  }
};

const mutations = {
  setCampaigns : (state,campaigns) => {
    state.campaigns = campaigns
  },
  setWizard : (state,wizard) => {
    state.wizard = wizard
  },
  setSelectedCampaign : (state,selectedCampaign) => {
    state.selectedCampaign = selectedCampaign
  }
};


const actions = {
  updateSelectedCampaign : async ({commit},selectedCampaign) => {
    commit('setSelectedCampaign', selectedCampaign)
  },
  updateCampaign : async ({commit},campaign) => {
    let result = await campaignService.saveCampaign(campaign)
    if(result){
      commit('setSelectedCampaign', campaign)
    }
    return
  },
  fetchWizard : async  ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.getCampaignWizard(data.business_uid)
      commit('setWizard',wizard )
    } catch (e) {
      console.log("fetchWizard", e)
    }
  },

  updateWizardFlags : async ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.updateWizardFlags(data.business_uid, data.wizard_id, data.flags)
      commit('setWizard', wizard)
    } catch (e) {
      console.log("updateWizardFlags", e)
    }
  },


  updateWizardCompleted: async ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.wizardCompleted(data.business_uid, data.wizard_id, data.flags)
      commit('setWizard', wizard)
      } catch (e) {
        console.log("updateWizardCompleted", e)
      }
    },


  fetchCampaigns : async ({commit}, payload) => {
    try {
      const campaigns = await campaignService.getCampaigns()
      commit('setCampaigns',campaigns.slice(0,4) )
    } catch (e) {
      console.log("fetchCampaigns", e)
    }
  },
  sendTestCampaign : async ({commit}, payload) => {
  try {
    let campaign =  _.cloneDeep(state.selectedCampaign)
    campaign.test = true
    let emailResult =  await campaignService.sendCampaign(campaign)
    campaign.channel = "sms"
    campaign.sms_content = state.selectedCampaign.title
    let smsResult =  await campaignService.sendCampaign(campaign)
    return smsResult
  } catch (e) {
    return e
  }
},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
